import React from 'react'
import exclamationIcon from '../../assets/icons/triangule-exclamation.svg'
import { t } from 'i18next'
import { CustomModal } from '../CustomModal/CustomModal'
export const RepeatedPlateErrorModal = ({ showModal, setShowModal, repeatedPlates }) => {
    return (
        <CustomModal
            showModal={showModal}
            setShowModal={setShowModal}
            centered
        >
            <div className='d-flex flex-column align-items-center justify-content-center'>
                <img
                    src={exclamationIcon}
                    alt="alert-icon"
                />
                <p className='mt-3 text-center param-section-title'>
                    {t('CANT_ADD_VEH_WITH_THE_SAME_PATENT')}
                </p>
                <p className='mt-1 text-center param-section-title'>
                    {`${t('PATENT')}: ${repeatedPlates.join(", ")}`}
                </p>
                <p
                    type="button"
                    className='custom-modal-btn-ok'
                    onClick={setShowModal}
                >
                    {t('UNDERSTOOD')}
                </p>
            </div>
        </CustomModal>
    )
}
